import { Box, Button } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import styles from "./MultipleCLSConfirmation.styles";
import SecureSyncModal from "src/components/common/SecureSyncModal/SecureSyncModal";

const MultipleCLSConfirmation = ({ open, handleConfirm, onClose, customerLocation }) => {
    const { t } = useTranslation();
    return (
        <SecureSyncModal
            open={open}
            title={t("containerPickup.addContainerContents")}
            footer={
                <Box sx={styles.confirmationModalFooter}>
                    <Button variant="contained" color="primary" onClick={handleConfirm}>
                        {t("buttonLabels.ok")}
                    </Button>
                    <Button autoFocus variant="outlined" onClick={onClose}>
                        {t("buttonLabels.cancel")}
                    </Button>
                </Box>
            }
        >
            <Trans
                i18nKey={"messages.userHasMultipleCSL"}
                values={{
                    csl: customerLocation,
                    okButtonLabel: t("buttonLabels.ok"),
                    cancelButtonLabel: t("buttonLabels.cancel"),
                }}
            />
        </SecureSyncModal>
    );
};

export default MultipleCLSConfirmation;
